import { MenuItem } from '@bea-shell/common/objects';

export class MenuItemEvent {
    menuItem: MenuItem
}